module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expect-job-info"
  }, [_c('p', {
    staticClass: "job-apply-text"
  }, [_vm._v("求职意向")]), _vm._v(" "), _c('div', [_c('title-intention', {
    ref: "zpcateId"
  }), _vm._v(" "), _c('salary-intention', {
    ref: "salary"
  }), _vm._v(" "), _c('area-intention', {
    ref: "targetAreaId"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e7d0a2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/jobIntention/index.vue
// module id = 354
// module chunks = 0